exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dropdown-padding {\r\n    margin-left: 5%;\r\n    margin-right: 5%;\r\n}\r\n\r\n.padding-underneath-tabs {\r\n    margin-top: 10%;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();